import React from 'react';
import { motion } from 'framer-motion';
export function BonusSection() {
  const bonuses = [{
    icon: '🥗',
    text: 'Alimentación y rendimiento'
  }, {
    icon: '💪',
    text: 'Kegel avanzado profundo'
  }, {
    icon: '🔥',
    text: 'Presencia en intimidad'
  }, {
    icon: '🧠',
    text: 'Reset de estímulo (porno + dopamina)'
  }, {
    icon: '📅',
    text: 'Plan de acción 14 días'
  }, {
    icon: '🎧',
    text: 'Audios hipnóticos de reprogramación'
  }];
  return <section className="relative w-full bg-[#0a0a0a] py-10 md:py-14 overflow-hidden" data-id="element-14">
      <div className="absolute inset-0 z-0" data-id="element-15">
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[500px] h-[500px] rounded-full bg-red-900/10 blur-[120px]" data-id="element-16" />
      </div>

      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-64 h-px bg-gradient-to-r from-transparent via-red-600 to-transparent z-20" data-id="element-17" />

      <div className="relative z-20 max-w-5xl mx-auto px-6" data-id="element-18">
        <motion.div initial={{
        opacity: 0,
        y: 15
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-19">
          {/* Compact header */}
          <div className="text-center mb-10" data-id="element-20">
            <div className="flex items-center justify-center gap-3 mb-4" data-id="element-21">
              <div className="w-10 h-px bg-red-600" data-id="element-22" />
              <span className="text-red-500 text-xs uppercase tracking-[0.3em] font-bold" data-id="element-23">
                Valor adicional
              </span>
              <div className="w-10 h-px bg-red-600" data-id="element-24" />
            </div>
            <h2 className="font-display md:text-5xl uppercase text-white drop-shadow-[0_0_20px_rgba(220,38,38,0.3)] text-[24px]" data-id="element-25">
              <span className="text-red-500" data-id="element-26">🎁</span> 6 Bonos exclusivos
              incluidos
            </h2>
          </div>

          {/* Compact 3-col grid */}
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3 md:gap-4" data-id="element-27">
            {bonuses.map((bonus, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 10
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.06,
            duration: 0.4
          }} className="relative bg-black/60 backdrop-blur-sm border border-red-900/40 p-4 rounded-lg shadow-[0_0_15px_rgba(220,38,38,0.05)] hover:border-red-600/50 hover:shadow-[0_0_25px_rgba(220,38,38,0.15)] transition-all duration-300 flex items-center gap-3" data-id="element-28">
                <div className="flex-shrink-0 w-10 h-10 rounded-lg bg-red-900/30 border border-red-800/40 flex items-center justify-center text-lg" data-id="element-29">
                  {bonus.icon}
                </div>
                <p className="text-sm md:text-base text-white font-medium" data-id="element-30">
                  {bonus.text}
                </p>
              </motion.div>)}
          </div>
        </motion.div>
      </div>
    </section>;
}